{
  "name": "@chancenwerk/chancen-kraefte",
  "displayName": "ChancenKräfte",
  "description": "The ChancenKräfte is the internal personel capacity management service of the Chancenwerk e.V.",
  "version": "1.0.0",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "adornis-cli project build --production --node-port 7000 --listen-port 3000",
    "test": "adornis-cli project test"
  },
  "dependencies": {
    "@adornis/base": "catalog:",
    "@adornis/baseql": "catalog:",
    "@adornis/calendar": "catalog:",
    "@adornis/chemistry": "catalog:",
    "@adornis/cms": "catalog:",
    "@adornis/fonts": "catalog:",
    "@adornis/config": "catalog:",
    "@adornis/data-view": "catalog:",
    "@adornis/filter": "catalog:",
    "@adornis/functional-lit": "catalog:",
    "@adornis/internationalization": "catalog:",
    "@adornis/router": "catalog:",
    "@adornis/translation-core": "catalog:",
    "@adornis/forms": "catalog:",
    "@adornis/dialog": "catalog:",
    "@adornis/user-forms": "catalog:",
    "@adornis/users": "catalog:",
    "@chancenwerk/client": "workspace:^",
    "@chancenwerk/translation-data": "workspace:^",
    "@chancenwerk/config": "workspace:^",
    "@chancenwerk/shared": "workspace:^",
    "@chancenwerk/enums": "workspace:^",
    "@chancenwerk/server": "workspace:^",
    "@lit-labs/preact-signals": "catalog:",
    "construct-style-sheets-polyfill": "catalog:",
    "lit": "catalog:",
    "luxon": "catalog:",
    "mingo": "catalog:",
    "node-schedule": "catalog:",
    "rxjs": "catalog:"
  },
  "devDependencies": {
    "@adornis/cli": "catalog:"
  },
  "files": [
    "dist"
  ],
  "license": "ISC"
}
